module.exports = __webpack_public_path__ + "static/media/9 copy.e2d5f750.jpg";